import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiServiceService } from '../../../shared/services/api-service.service';
import { environment } from '../../../../../../../public/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CVService {

    constructor(private apiService: ApiServiceService) { }

    getPersonalCV(): any {
        return this.apiService.get(`${environment.apiUrl}/profile/cv/my-personal-cv`)
            .pipe(catchError(this.handleError));
    }
    getCompetencyCV(): any {
        return this.apiService.get(`${environment.apiUrl}/profile/cv/competency-based-cv`)
            .pipe(catchError(this.handleError));
    }
    checkApplicantCV(applicantId: string): any {
        return this.apiService.getWithoutError(`${environment.apiUrl}/profile/cv/check-applicant-cv?applicant_id=${applicantId}`)
    }
    printPersonalCv() {
        return this.apiService.get(`${environment.apiUrl}/profile/cv/download-my-cv`)
            .pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }
}
